export type Section = 'overview' | 'loops' | 'runs' | 'engines' | 'models' | 'users' | 'sites'
export type DataSection = Exclude<Section, 'overview'>
export type RecordRow = Record<string, unknown>
export type Payload = { overview: Record<string, number>; loops: RecordRow[]; runs: RecordRow[]; engines: RecordRow[]; models: RecordRow[]; users: RecordRow[]; sites: RecordRow[]; warnings: string[]; generatedAt: string }
export const emptyPayload: Payload = { overview: {}, loops: [], runs: [], engines: [], models: [], users: [], sites: [], warnings: [], generatedAt: '' }

export function isPayload(value: unknown): value is Payload {
  if (!value || typeof value !== 'object') return false
  const candidate = value as Partial<Payload>
  return Boolean(candidate.overview && typeof candidate.overview === 'object'
    && ['loops', 'runs', 'engines', 'models', 'users', 'sites'].every(key => Array.isArray(candidate[key as DataSection]))
    && typeof candidate.generatedAt === 'string')
}
